import { HasKind } from '@/utilities/HasKind';

export const kind = 'EventsTracked';

export type EventsTracked = HasKind<typeof kind>;

export const eventsTracked: EventsTracked = { kind };
